import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useForm, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import SearchInput from '../../../components/common-inputs/SearchInput';
import AccessContainers from '../../../components/access-containers/AccessContainers';
import useAccessProjectsOptions from './useAccessProjectsOptions';

import scss from './AssignProjects.module.scss';

const AssignProjects = () => {
  const { t } = useTranslation('customers');
  const { change } = useForm();
  const { values, submitting } = useFormState();

  const { projectSearch, accessProjects, handleSearchProjects, handleLoadMoreProjects } = useAccessProjectsOptions();
  const isAccessProjectLoading = useSelector((state) => state.customers.isAccessProjectsLoading);
  const totalAccessProjects = useSelector((state) => state.customers.accessProjectsTotal);

  const inactiveProjects = useMemo(
    () =>
      accessProjects.filter(
        (project) => !values.assignedProjects.some((activeProject) => activeProject.id === project.id),
      ),
    [values, accessProjects],
  );

  const handleAssignProject = useCallback(
    (project) => {
      change('assignedProjects', [...values.assignedProjects, project]);
    },
    [values, change],
  );

  const handleRemoveProject = useCallback(
    ({ id }) => {
      change(
        'assignedProjects',
        values.assignedProjects.filter((project) => project.id !== id),
      );
    },
    [values, change],
  );

  return (
    <div className={scss.assignProjectsSection}>
      <WithLabel variant={LABEL_STYLES.ROW} label={t('assignProjects')}>
        <SearchInput
          value={projectSearch}
          onChange={handleSearchProjects}
          size='sm'
          maxWidth={320}
          name='project-search'
        />
      </WithLabel>

      <Field name='assignedProjects'>
        {({ input }) => (
          <AccessContainers
            onInactive={handleRemoveProject}
            onActive={handleAssignProject}
            inactive={inactiveProjects}
            active={input.value}
            disabled={submitting}
            isLoading={isAccessProjectLoading}
            searchStr={projectSearch}
            onLoadMore={handleLoadMoreProjects}
            totalElements={totalAccessProjects}
            inactiveLoadedSize={accessProjects.length}
          />
        )}
      </Field>
    </div>
  );
};

export default AssignProjects;
